import React from "react";
import { ContactUs } from "../components/emai";
import { ContactInfo, ContactWrapper, Info } from "../styles/contact";
import PhoneIcon from "@mui/icons-material/Phone";
import TelegramIcon from "@mui/icons-material/Telegram";
import EmailIcon from "@mui/icons-material/Email";
import { NameCon } from "../styles/home";

const Contact = () => {
  return (
    <ContactWrapper>
      <NameCon>
        <p>Let’s talk for your project done</p>
      </NameCon>
      <ContactInfo>
        <Info>
          <h1>Get in touch with me!</h1>{" "}
          <h4>
            <PhoneIcon /> Contact Number: <span>+821082547679</span>
          </h4>
          <h4>
            {" "}
            <TelegramIcon /> Telegram:{" "}
            <a href="https://t.me/unbemon">https://t.me/unbemon</a>
          </h4>
          <h4>
            {" "}
            <EmailIcon /> Email me:
            <span>the.mechanic99@bk.ru</span>
          </h4>
        </Info>
        <ContactUs />
      </ContactInfo>
    </ContactWrapper>
  );
};

export default Contact;
